const KEY = 'mgr_auth_redirect';

function isSafePath(path) {
    if (!path || typeof path !== 'string') {
        return false;
    }
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
        return false;
    }
    return true;
}

export default {

    clear() {
        sessionStorage.removeItem(KEY);
    },

    consume() {
        const path = this.peek();
        sessionStorage.removeItem(KEY);
        return path;
    },

    peek() {
        const path = sessionStorage.getItem(KEY);
        return this.safePath(path);
    },

    remember(path) {
        if (!this.safePath(path)) {
            return;
        }
        sessionStorage.setItem(KEY, path);
    },

    rememberFromRoute(route) {
        const path = route?.query?.redirect || route?.query?.r;
        this.remember(path);
    },

    safePath(path) {
        return isSafePath(path) ? path : null;
    },

};
